// extracted by mini-css-extract-plugin
export default {"container":"EmailUnsubscribe_container--d4f","icon":"EmailUnsubscribe_icon--f8u","submit":"EmailUnsubscribe_submit--oVE"};